import React from 'react'

// import { Name } from '@/constants/manifast'
import useMediaQuery from '@/hooks/useMediaQuery'

import { Container, Flex } from '../common/Box'
// import { Exo2Text } from '../common/Text'
import ConnectWallet from '../ConnectWallet'

// import CreateToken from '../CreateToken'
// import Language from '../Language'
// import GlobalPriorityFee from '../settings/GlobalPriorityFee'
// import GlobalSettings from '../settings/GlobalSettings'
// import ThemeChange from '../ThemeChange'
import Contacts from './Contacts'
import LogoWithName from './LogoWithName'
import Navs from './Navs'

const Header: React.FC = () => {
  const { gtXL } = useMediaQuery()

  return (
    <>
      <header className="header fixed top-0 z-10 w-full">
        <Container className="max-w-none !py-0">
          <Flex className="relative h-[50px] items-center justify-between xl:h-[72px] xl:justify-center">
            {gtXL ? (
              <>
                <Flex className="absolute left-0 items-center gap-5">
                  <LogoWithName />
                  <Contacts />
                </Flex>
                <Navs />
              </>
            ) : (
              <LogoWithName />
            )}
            {gtXL ? (
              <Flex className="right-0 gap-1 xl:absolute">
                {/* <CreateToken /> */}
                {/* <Flex>
                  <GlobalPriorityFee
                    wrapperClassName="pr-0 rounded-r-none"
                    className="rounded-r-none"
                  />
                  <GlobalSettings
                    wrapperClassName="rounded-l-none"
                    className="rounded-l-none"
                  />
                </Flex> */}
                {/* <Language /> */}
                {/* <ThemeChange /> */}
                <ConnectWallet />
              </Flex>
            ) : (
              <Flex className="gap-2">
                <Contacts />
                  {/* <GlobalPriorityFee /> */}
                  {/* <GlobalSettings /> */}
                <ConnectWallet />
              </Flex>
            )}
          </Flex>
        </Container>
      </header>
      <div className="h-[50px] lg:h-[72px]" />
    </>
  )
}

export default Header
